import type { IconSvgObject } from './types';

const Sine02Icon: IconSvgObject = [
  ["path", { d: "M20 9.011C20 12.0001 19.1883 21 15.7132 21C13.8952 21 12.7411 17.3802 11.9999 12.0001C11.2587 6.61994 10.1048 3 8.28678 3C4.81171 3 4 12.0001 4 14.989", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.5 11.9999L5.5 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.5 12H9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14.5 12L15.5 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M18.5 12H21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Sine02Icon;
